// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrganizationTile_wrapper__kRzh0","link":"OrganizationTile_link__16xYa","icon":"OrganizationTile_icon__Ujij_","name":"OrganizationTile_name__smGzv"};